import React from 'react';
import { Navigate } from 'react-router-dom';

interface SecretRouteProps {
  children: React.ReactNode;
}

export default function SecretRoute({ children }: SecretRouteProps) {
  const hasAccess = localStorage.getItem('odc_admin_access') === 'true';

  if (!hasAccess) {
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
}
